import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";




import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import GstList from "../../components/masters/gst/GstList";
import GstEntry from "../../components/masters/gst/GstEntry";


import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";



const Gst = () => {
  const [visible, setVisible] = useState(false);
  const [gstAddData, setGstAddData] = useState({
    id: 0,
    gstDescription: '',
    gstType: '',
    rate: '',
    accountId: '',
    usedfor: '',
    mode: ADD_MODE
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="GST"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
              <PlusOutlined /> Add
            </Button>,
          ]}
        ></PageHeader>

        <Drawer
          title="Add new GST"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <GstEntry data={gstAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView">
        <div className="form-content">
          <GstList />
        </div>
        </div>

      </div>
    </div>
  )
}

export default Gst